(() => {
  'use strict';
  if (window.NLVProductReviewNotice) { window.NLVProductReviewNotice.init(document); return; }
  const instances = new Map();
  const sessionKey = 'nlv-product-review-notice:seen:v1';
  const init = scope => scope.querySelectorAll('[data-product-review-notice]').forEach(notice => {
    if (instances.has(notice)) return;
    const score = Number(notice.dataset.reviewScore), count = Number(notice.dataset.reviewCount), scale = Number(notice.dataset.reviewScale);
    const valid = Number.isFinite(score) && score > 0 && score <= 5 && scale === 5 && Number.isSafeInteger(count) && count > 0;
    let alreadySeen = false;
    try { alreadySeen = sessionStorage.getItem(sessionKey) === '1'; } catch (_) {}
    if (!valid || alreadySeen || window.Shopify?.designMode) { notice.hidden = true; return; }
    const abort = new AbortController(), options = { signal: abort.signal };
    const link = notice.querySelector('[data-review-notice-link]');
    const summary = document.getElementById(link?.getAttribute('href')?.slice(1));
    if (!link || !summary) return;
    // Link to the real review widget when it exists; otherwise use the visible rating summary.
    if (document.getElementById('judgeme_product_reviews')) link.setAttribute('href', '#judgeme_product_reviews');
    let ready = false, finished = false, shown = false, hovered = false, focused = false, shownAt = null, remaining = 10000, lifeTimer;
    const visible = element => Boolean(element && !element.hidden && element.getClientRects().length && getComputedStyle(element).display !== 'none' && getComputedStyle(element).visibility !== 'hidden');
    const busy = () => document.visibilityState !== 'visible' || Boolean(document.querySelector('[data-intro]:not([hidden]),dialog[open],[data-purchase-toast]:not([hidden])')) ||
      [...document.querySelectorAll('#shopify-pc__banner,#shopify-pc__prefs,[aria-modal="true"]')].some(visible) ||
      Boolean(document.querySelector('[data-nlv-privacy]') && (!window.NLVPrivacy?.ready || window.NLVPrivacy.nativeVisible() || window.NLVPrivacy.needsChoice()));
    const pauseClock = () => {
      clearTimeout(lifeTimer);
      if (shownAt !== null) { remaining = Math.max(0, remaining - (performance.now() - shownAt)); shownAt = null; }
    };
    const pause = () => { pauseClock(); notice.hidden = true; };
    const finish = (restoreFocus = false) => {
      if (finished) return;
      finished = true; pause();
      if (restoreFocus && notice.contains(document.activeElement)) summary.focus({ preventScroll: true });
      observer.disconnect(); abort.abort(); clearTimeout(delayTimer); instances.delete(notice);
    };
    const startClock = () => {
      if (hovered || focused || shownAt !== null || notice.hidden) return;
      shownAt = performance.now(); lifeTimer = setTimeout(() => finish(), remaining);
    };
    const overlapsPurchase = () => {
      const rect = notice.getBoundingClientRect();
      return [...document.querySelectorAll('[data-add-button],.shopify-payment-button,.bale-secondary-button--product,[data-bale-add]')].filter(visible).some(control => {
        const target = control.getBoundingClientRect();
        return rect.left < target.right + 10 && rect.right > target.left - 10 && rect.top < target.bottom + 10 && rect.bottom > target.top - 10;
      });
    };
    const attempt = () => {
      if (finished || !ready || !notice.isConnected) return;
      if (busy()) { if (!notice.hidden) pause(); return; }
      if (remaining <= 0) { finish(); return; }
      const top = Math.max(0, document.querySelector('.header-shell')?.getBoundingClientRect().bottom || 0) + 12 + 'px';
      if (notice.style.getPropertyValue('--review-notice-top') !== top) notice.style.setProperty('--review-notice-top', top);
      // Measure an invisible candidate before showing, so purchase controls always stay clear.
      const hidden = notice.hidden;
      if (hidden) { notice.style.visibility = 'hidden'; notice.hidden = false; }
      const overlaps = overlapsPurchase();
      if (hidden) { notice.hidden = true; notice.style.visibility = ''; }
      if (overlaps) { if (!notice.hidden) pause(); return; }
      if (!shown) { shown = true; try { sessionStorage.setItem(sessionKey, '1'); } catch (_) {} }
      notice.hidden = false; startClock();
    };
    const observer = new MutationObserver(records => {
      // Our own measuring/hiding mutations must not create an observer loop.
      if (records.some(record => !notice.contains(record.target))) attempt();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'open', 'aria-hidden', 'style', 'class'] });
    notice.querySelector('[data-review-notice-close]')?.addEventListener('click', () => finish(true), options);
    link.addEventListener('click', () => finish(), options);
    notice.addEventListener('keydown', event => { if (event.key === 'Escape') finish(true); }, options);
    notice.addEventListener('pointerenter', () => { hovered = true; pauseClock(); }, options);
    notice.addEventListener('pointerleave', () => { hovered = false; startClock(); }, options);
    notice.addEventListener('focusin', () => { focused = true; pauseClock(); }, options);
    notice.addEventListener('focusout', event => { focused = notice.contains(event.relatedTarget); if (!focused) startClock(); }, options);
    document.addEventListener('visibilitychange', attempt, options);
    document.addEventListener('nlv:privacy:ready', attempt, options);
    window.addEventListener('scroll', attempt, { ...options, passive: true });
    window.addEventListener('resize', attempt, { ...options, passive: true });
    window.addEventListener('pagehide', () => finish(), options);
    const delayTimer = setTimeout(() => { ready = true; attempt(); }, 12000);
    instances.set(notice, { dispose: () => finish() });
  });
  window.NLVProductReviewNotice = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-product-review-notice]').forEach(notice => instances.get(notice)?.dispose());
  });
})();
